import { getMaxValueByKey, getMinValueByKey } from '../index'

export const getPrice = racesDetail => {
  const min = getMinValueByKey(racesDetail, 'price').price
  const max = getMaxValueByKey(racesDetail, 'price').price

  return min === max ? min : `${min} - ${max}`
}

export const getParticipantUnit = participant =>
  participant.race_detail.race.is_walk ? 'ก้าว' : 'km'



// WEBPACK FOOTER //
// /opt/build/repo/src/utils/run/index.js